import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// SD-1137: Catches backend 403s with body { error: "email_not_confirmed" } emitted by the
// RequireEmailConfirmed filter and broadcasts an event that the VerificationRequiredModal
// component subscribes to. Using a static Subject avoids a circular DI dependency between
// this interceptor and the modal's host component.
@Injectable({ providedIn: 'root' })
export class EmailConfirmedInterceptor implements HttpInterceptor {
  static readonly emailNotConfirmed$ = new Subject<void>();

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 403) {
          const body = error.error;
          const code = typeof body === 'string'
            ? this.safeParse(body)?.error
            : body?.error;
          if (code === 'email_not_confirmed') {
            EmailConfirmedInterceptor.emailNotConfirmed$.next();
          }
        }
        return throwError(error);
      })
    );
  }

  private safeParse(s: string): any {
    try { return JSON.parse(s); } catch { return null; }
  }
}
